import { ReactNode, useEffect } from 'react';
import styled from 'styled-components';
import { Typography } from '@mui/material';
import { Dialog } from '@elementary/common-ui/components';
import { IntegrationError } from 'settings/types';
import IntegrationErrorAlert from './IntegrationErrorAlert';

const Link = styled.a`
  color: ${({ theme }) => theme.palette.common.blue4};
`;

type Props = {
  open: boolean;
  title: string;
  description?: string;
  docsLink?: string;
  children: ReactNode;
  onClose: () => void;
  onSubmit?: () => void;
  isValid?: boolean;
  error?: IntegrationError;
  reset?: () => void;
  loading?: boolean;
  hideSaveButton?: boolean;
  saveButtonText?: string;
  width?: number;
};

const IntegrationDialog = ({
  open,
  title,
  description,
  docsLink,
  children,
  onClose,
  onSubmit,
  isValid = true,
  error,
  reset,
  loading,
  hideSaveButton,
  saveButtonText,
  width = 870,
}: Props) => {
  useEffect(() => {
    if (open) {
      reset?.();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      title={title}
      onConfirmButtonClick={() => onSubmit?.()}
      isLoading={loading}
      confirmText={saveButtonText || 'Save'}
      cancelText="Close"
      confirmDisabled={!isValid}
      hideConfirmButton={hideSaveButton}
      customWidth={width}
      closeOnBackdropClick={false}
    >
      {description && (
        <Typography>
          {description}
          {docsLink && (
            <>
              {' '}
              Check our{' '}
              <Link href={docsLink} target="_blank" rel="noopener noreferrer">
                docs
              </Link>{' '}
              for more info.
            </>
          )}
        </Typography>
      )}
      {children}
      {error && <IntegrationErrorAlert error={error} />}
    </Dialog>
  );
};

export default IntegrationDialog;
